<template>
  <div class="container" v-if="$can(['SuperAdmin', 'manager'])">
    <div class="box-title" :style="{marginTop: '-15px'}">
      <h4>
        <i class="fal fa-truck"></i>
        {{ $t("externalShipments.orders_title") }}
        <span class="countTotal">({{ count }})</span>
        <span class="btn-add" :style="{marginTop: '-5px !important'}">
          {{ $t("ລາຍການOrderພັດສະດຸ.ຄ່າຂົນສົ່ງ") }}: {{ FormatPrice(totalFreight) }}
          | {{ $t("externalShipments.hal_service_fee") }}: {{ FormatPrice(serviceFeeTotal) }}
        </span>
        <span class="btn-add">
          <div class="columns">
            <div class="field" :style="{marginRight: '5px'}">
              <vs-button
                  ref="button" flat
                  @click="ExportOrders()"
                  class="form-btn-loading"
                  :loading="loading"
                  :disabled="listAllOrders.length <= 0">
                Export excel
              </vs-button>
            </div>
            <div class="field" style="margin-right: 12px">
              <vs-button
                  ref="button"
                  @click="ClearData()"
                  class="form-cls-loading"
                  :loading="loading">
                {{ $t("ລາຍການOrderພັດສະດຸ.ລ້າງຂໍ້ມູນ") }}
              </vs-button>
            </div>
          </div>
        </span>
      </h4>
    </div>

    <div class="box" style="margin-bottom: 12px;margin-top: -12px;">
      <div class="columns">
        <div class="column is-3">
          <div class="field">
            <div class="control">
              <label class="label">{{ $t("ລາຍການOrderພັດສະດຸ.ຄົ້ນຫາ") }}:</label>
              <input class="input" :placeholder="$t('externalShipments.search_placeholder')"
                     v-model="searchItem" @keyup.enter="FilterOrders()">
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="control">
            <label class="label">{{ $t("ລາຍການOrderພັດສະດຸ.ສະຖານະ") }}:</label>
            <div class="select">
              <select class="input" v-model="selectedStatusGroup" @change="FilterOrders()">
                <option v-for="(item, index) in statusGroups" :key="index" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-3">
          <div class="control">
            <label class="label">{{ $t("ລາຍການOrderພັດສະດຸ.ສາຂາຕົ້ນທາງ") }}:</label>
            <model-list-select
                :list="startBranches"
                v-model="selectedStartBranch"
                :placeholder="$t('ລາຍການOrderພັດສະດຸ.ເລືອກສາຂາຕົ້ນທາງ')"
                option-text="name"
                option-value="id"
                selectedItem="name"
                @input="FilterOrders()"
            >
            </model-list-select>
          </div>
        </div>
        <div class="column is-2">
          <div class="control field">
            <label class="label">{{ $t("ລາຍການOrderພັດສະດຸ.ຈາກວັນທີ") }}:</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                v-model="fromDate"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                @change="FilterOrders()"
            ></date-picker>
          </div>
        </div>
        <div class="column is-2">
          <div class="control field">
            <label class="label">{{ $t("ລາຍການOrderພັດສະດຸ.ຫາວັນທີ") }}:</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                v-model="toDate"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                @change="FilterOrders()"
            ></date-picker>
          </div>
        </div>
      </div>

      <vs-table ref="table">
        <template #thead>
          <vs-tr>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ເລກທີບິນ") }}</vs-th>
            <vs-th>{{ $t("externalShipments.hal_bill_number") }}</vs-th>
            <vs-th>{{ $t("externalShipments.created_date") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ສະຖານະ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ຈຳນວນ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ຄ່າຂົນສົ່ງ") }}</vs-th>
            <vs-th>{{ $t("externalShipments.hal_service_fee") }}</vs-th>
            <vs-th>{{ $t("externalShipments.price_or_cod") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ຊື່ຜູ້ສົ່ງ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ຊື່ຜູ້ຮັບ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ສາຂາຕົ້ນທາງ") }}</vs-th>
            <vs-th>{{ $t("externalShipments.destination_hub") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ປະເພດການຊຳລະ") }}</vs-th>
            <vs-th>{{ $t("externalShipments.provider") }}</vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
              :key="index"
              v-for="(item, index) in listAllOrders"
              :data="item">
            <vs-td :style="{color: 'crimson'}">( {{ item.shipment_number }} )</vs-td>
            <vs-td>{{ item.hal_tracking_number }}</vs-td>
            <vs-td>{{ FormatDate(item.start_date_actual) }}</vs-td>
            <vs-td>{{ nullsafe(item, (t) => t.shipment_status.name) }}</vs-td>
            <vs-td>{{ item.pieces || 0 }}</vs-td>
            <vs-td :style="{color: 'crimson'}">( {{ FormatPrice(item.total_freight) }} )</vs-td>
            <vs-td :style="{color: 'crimson'}">( {{ FormatPrice(item.service_fee_amount) }} )</vs-td>
            <vs-td>( {{ FormatPrice(item.total_price) }} )</vs-td>
            <vs-td>{{ nullsafe(item, t => t.sender_customer.name) }}</vs-td>
            <vs-td>{{ nullsafe(item, t => t.receiver_customer.name) }}</vs-td>
            <vs-td>{{ nullsafe(item, t => t.start_branch.name) }}</vs-td>
            <vs-td>
              {{ nullsafe(item, t => t.end_branch.hub_name) || nullsafe(item, t => t.end_branch.name) }}
            </vs-td>
            <vs-td>{{ la_pay_type[item.shipment_pay_type] || item.shipment_pay_type }}</vs-td>
            <vs-td>{{ item.external_provider }}</vs-td>
          </vs-tr>
        </template>
        <template #footer>
          <pagination :pagination="pagination" :offset="offset"
                      @paginate="FetchData()"></pagination>
          <Loading v-if="isLoading"/>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import Loading from '../../Loading';
import moment from 'moment';
import MixinListExternalOrders from '../../../Mixins/ExternalShipments/ListExternalOrders';
import DatePicker from "vue2-datepicker";
import {ModelListSelect} from 'vue-search-select';
import pagination from '../../../Plugins/Paginations/Pagination';

export default {
  components: {
    Loading,
    DatePicker,
    ModelListSelect,
    pagination,
  },

  mixins: [MixinListExternalOrders],

  methods: {
    FormatPrice(num) {
      var p = (num || 0).toFixed(2).split(".");
      return p[0].split("").reverse().reduce(function (acc, num, i) {
        return num == "-" ? acc : num + (i && !(i % 3) ? "," : "") + acc;
      }, "") + ' ' + this.$t('common.ກີບ');
    },
    FormatDate(value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY HH:mm');
      }
    },
  },
  created() {
    this.FetchListStartBranch();
    this.FetchData();
  },
}
</script>
